"use client";

import { c as _c } from "react/compiler-runtime";
import { DocumentActionsProvider } from "@hooks/pages/use-document-actions";
import React, { ReactNode } from "react";
import { usePathname } from "next/navigation";
import { SidePanelProvider } from "@components/common/containers/side-panel/side-panel-provider";
import { Document } from "@components/document/document";
import { DocumentLoader, DocumentLoaderProvider } from "@components/document/document-loader";
import { PageHeader } from "@components/page/page-header";
import { SidebarInset, SidebarProvider } from "@components/ui/sidebar";
import { AppSidebar } from "@features/application/ui/app-sidebar";
interface GlobalShellProps {
  children: ReactNode;
  sideBarState: boolean;
  isLogged: boolean;
  isPrivateMode: boolean;
  showDesignSystemUtilityAction: boolean;
}
export function GlobalShell(t0) {
  const $ = _c(19);
  const {
    children,
    sideBarState,
    isLogged,
    isPrivateMode,
    showDesignSystemUtilityAction
  } = t0;
  const pathname = usePathname();
  if (pathname === "/") {
    let t1;
    if ($[0] !== children) {
      t1 = <>{children}</>;
      $[0] = children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== isLogged || $[3] !== isPrivateMode || $[4] !== showDesignSystemUtilityAction) {
    t1 = isLogged && <AppSidebar isPrivateMode={isPrivateMode} showDesignSystemUtilityAction={showDesignSystemUtilityAction} />;
    $[2] = isLogged;
    $[3] = isPrivateMode;
    $[4] = showDesignSystemUtilityAction;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isLogged || $[7] !== showDesignSystemUtilityAction) {
    t2 = <PageHeader isLogged={isLogged} showDesignSystemUtilityAction={showDesignSystemUtilityAction} />;
    $[6] = isLogged;
    $[7] = showDesignSystemUtilityAction;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children) {
    t3 = <div data-slot="document-scroll-container" className="overflow-x-hidden md:overflow-x-auto"><Document>{children}</Document></div>;
    $[9] = children;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DocumentLoader />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3) {
    t5 = <SidebarInset className="flex h-screen flex-col overflow-y-auto"><DocumentActionsProvider><DocumentLoaderProvider><SidePanelProvider>{t2}{t3}{t4}</SidePanelProvider></DocumentLoaderProvider></DocumentActionsProvider></SidebarInset>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== sideBarState || $[16] !== t1 || $[17] !== t5) {
    t6 = <SidebarProvider open={sideBarState}>{t1}{t5}</SidebarProvider>;
    $[15] = sideBarState;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}